import { makeRequest } from 'utils/requestLogger';

export default (discussion_id, hand_raise_type) =>
  makeRequest(
    'put',
    `/api/live_discussions/${discussion_id}/auto_turn_speaker`,
    { hand_raise_type }
  );



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/queue/autoTurnSpeaker.js